import * as React from 'react';

import * as styles from './styles.css';
import { CollapsedBlock, ICollapsedButtonProps } from '../CollapsedBlock';

export interface IPromos {
  Button: React.ComponentType<React.PropsWithChildren<ICollapsedButtonProps>>;
  onChangeOpen(opened: boolean): void;
}

export const Promos = ({ children, Button, onChangeOpen }: React.PropsWithChildren<IPromos>) => {
  return (
    <div className={styles['promos']}>
      <CollapsedBlock Button={Button} onChangeOpen={onChangeOpen}>
        {children}
      </CollapsedBlock>
    </div>
  );
};
